export default __webpack_public_path__ + "static/tanulo_6-b400a8ad4d4f11193b8b43447a186262.webp";